"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GallonsPerHour = exports.GallonsPerMinute = exports.LiterPerHour = exports.LiterPerMinute = exports.LiterPerSecond = exports.HundredCubicFeetPerHour = exports.CubicFeetPerHour = exports.CubicFeetPerMinute = exports.CubicMeterPerHour = exports.CubicMeterPerSecond = void 0;
var uom_1 = require("uom");
// VolumeFlow
exports.CubicMeterPerSecond = uom_1.UnitFormat.createUnitFormat("m³/s", 2);
exports.CubicMeterPerHour = uom_1.UnitFormat.createUnitFormat("m³/h", 1);
exports.CubicFeetPerMinute = uom_1.UnitFormat.createUnitFormat("ACFM", 1);
exports.CubicFeetPerHour = uom_1.UnitFormat.createUnitFormat("ACFH", 0);
exports.HundredCubicFeetPerHour = uom_1.UnitFormat.createUnitFormat("cch", 0);
exports.LiterPerSecond = uom_1.UnitFormat.createUnitFormat("l/s", 3);
exports.LiterPerMinute = uom_1.UnitFormat.createUnitFormat("l/m", 2);
exports.LiterPerHour = uom_1.UnitFormat.createUnitFormat("l/h", 2);
exports.GallonsPerMinute = uom_1.UnitFormat.createUnitFormat("gal/min", 1);
exports.GallonsPerHour = uom_1.UnitFormat.createUnitFormat("gal/h", 2);
//# sourceMappingURL=volume-flow-format.js.map